import { configureStore } from "@reduxjs/toolkit";
import UploadReducer from "./reducers/UploadReducer";
import DownloadReducer from "./reducers/DownloadReducer";
import { combineReducers } from "redux";

const reducer = combineReducers({
  upload: UploadReducer,
  download: DownloadReducer
});

const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "upload/addFileToQueue",
          "upload/updateFileStatus",
          "upload/setFileBlockQueue",
          "upload/uploadToBlobStorage/fulfilled",
          "upload/addFileToUploadQueueChunked/fulfilled",
          "upload/uploadToBlobStorageChunked/fulfilled",
          "upload/addFileToUploadQueue/fulfilled",
          "upload/createBlockBlobClient",
          "upload/setBlockQueue",
          "upload/createBlockBlobClient/fulfilled",
          "upload/setCurrentItem"
        ],
        ignoredPaths: ["upload"]
      }
    }),
  devTools: true
});

export default store;
